import React, { useState, useEffect } from 'react';
import { ReactComponent as Drag } from 'src/Images/icons/common/drag.svg';
import { ReactComponent as Close } from 'src/Images/icons/common/close.svg';
import { useSelector } from 'react-redux';
import getColorCode from 'src/utils/GetThemeColor';

export default function TableRightDrawer({
  toggleDrawer,
  fieldFilter,
  selectedFieldFilter,
  handleSelectedFieldFilter,
  setDraggedFieldOrder,
}) {
  const authReducer = useSelector((state) => state.authReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const [orderedFields, setOrderedFields] = useState(
    fieldFilter.map(({ value, label }) => ({
      id: value,
      name: label,
    })),
  );

  useEffect(() => {
    setDraggedFieldOrder(
      orderedFields
        .filter(({ id }) => selectedFieldFilter.includes(id))
        .map(({ id }) => id),
    );
  }, [orderedFields, selectedFieldFilter, setDraggedFieldOrder]);

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData('draggedIndex', index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, dropIndex) => {
    const draggedIndex = parseInt(e.dataTransfer.getData('draggedIndex'), 10);
    if (draggedIndex === dropIndex) return;

    const updatedFields = [...orderedFields];
    const [draggedItem] = updatedFields.splice(draggedIndex, 1);
    updatedFields.splice(dropIndex, 0, draggedItem);

    setOrderedFields(updatedFields);
    updateDraggedFieldOrder(updatedFields);
  };

  const updateDraggedFieldOrder = (updatedFields) => {
    const updatedDraggedOrder = updatedFields
      .filter(({ id }) => selectedFieldFilter.includes(id))
      .map(({ id }) => id);
    setDraggedFieldOrder(updatedDraggedOrder);
  };

  const handleCheckboxChange = (e, id) => {
    handleSelectedFieldFilter(e, id);
  };

  const checkedFields = orderedFields.filter(({ id }) =>
    selectedFieldFilter.includes(id),
  );
  const uncheckedFields = orderedFields.filter(
    ({ id }) => !selectedFieldFilter.includes(id),
  );

  return (
    <div>
      <div className="px-3 py-2 border-bottom div-space-between div-align-center">
        <span className="text-sm text-bold">Organizer</span>
        <button
          className="icon-btn-none"
          onClick={toggleDrawer(false)}
          aria-label="close-button"
        >
          <Close className="icon-size-sm" color={getColorCode(themeColor)} />
        </button>
      </div>
      <div className="px-3 py-3 div-flex-column rg-20">
        {checkedFields.map(({ id, name }, index) => (
          <div
            className="div-space-between"
            key={id}
            draggable
            onDragStart={(e) =>
              handleDragStart(e, orderedFields.indexOf(checkedFields[index]))
            }
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, index)}
          >
            <div className="div-flex-row cg-10">
              <input
                type="checkbox"
                className="checkbox-grey"
                checked={selectedFieldFilter.includes(id)}
                onChange={(e) => handleCheckboxChange(e, id)}
              />
              <span className="text-sm">{name}</span>
            </div>
            <Drag className="icon-size-lg" color="#DBDBDB" />
          </div>
        ))}
        {checkedFields.length > 0 && <div className="border-bottom" />}
        {uncheckedFields.map(({ id, name }) => (
          <div className="div-flex-row cg-10" key={id}>
            <input
              type="checkbox"
              className="checkbox-grey"
              checked={selectedFieldFilter.includes(id)}
              onChange={(e) => handleCheckboxChange(e, id)}
            />
            <span className="text-sm">{name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
